import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ConversationsListComponent } from './components/conversations-list/conversations-list.component';
import { FriendsListComponent } from './components/friends-list/friends-list.component';
import { FriendRequestsComponent } from './components/friend-requests/friend-requests.component';
import { FriendItemComponent } from './components/friend-item/friend-item.component';
import { InvitationItemComponent } from './components/invitation-item/invitation-item.component';
import { BadgeCountComponent } from './components/badge-count/badge-count.component';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, SharedModule],
    declarations: [
        ConversationsListComponent,
        FriendsListComponent,
        FriendRequestsComponent,
        FriendItemComponent,
        InvitationItemComponent,
        BadgeCountComponent,
    ],
    providers: [InAppBrowser],
})
export class MessengerModule {}
